export default __webpack_public_path__ + "static/media/zaheer_ahmed_daughter.645e87e1.jpg";